import { render } from "./Chatbots.vue?vue&type=template&id=1e062047&scoped=true&ts=true"
import script from "./Chatbots.vue?vue&type=script&lang=ts"
export * from "./Chatbots.vue?vue&type=script&lang=ts"

import "./Chatbots.vue?vue&type=style&index=0&id=1e062047&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e062047"]])

export default __exports__